import { render } from "./HowToPage.vue?vue&type=template&id=5dec08ee&scoped=true"
import script from "./HowToPage.vue?vue&type=script&lang=js"
export * from "./HowToPage.vue?vue&type=script&lang=js"

import "./HowToPage.vue?vue&type=style&index=0&id=5dec08ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dec08ee"]])

export default __exports__